{
  "fields": {
    "category": {
      "label": "Catégorie",
      "placeholder": "Rechercher par catégorie"
    },
    "type": {
      "label": "Typologie",
      "placeholder": "Rechercher par typologie"
    },
    "health_type": {
      "label": "Type de professionnel de santé",
      "placeholder": "Rechercher par type de PS"
    },
    "name": {
      "label": "Nom / Prénom / Intitulé",
      "placeholder": "Rechercher par nom / prénom / intitulé"
    },
    "submission_regime": {
      "label": "Régime de soumission",
      "placeholder": "Rechercher par régime de soumission"
    },
    "pack": {
      "label": "Pack d'avantages",
      "placeholder": "Rechercher par pack d'avantages"
    },
    "created_by": {
      "label": "Ajouté par",
      "placeholder": "Rechercher par ajouté par"
    },
    "ticket_badge": {
      "label": "Étape de validation :",
      "placeholder": "Étape",
      "CREATING": "En création",
      "TO_EDIT": "À modifier",
      "CANCELED": "Annulé",
      "ARCHIVED": "Archivé",
      "PUBLISHED": "Publié",
      "DECLARED": "Déclaré",
      "FIRST_VALIDATION": "Première validation",
      "SECOND_VALIDATION": "Deuxième validation",
      "CONTRACT_MANAGEMENT": "En cours de soumission & gestion",
      "EVENT_IN_PROGRESS": "Évènement en cours",
      "EVENT_VALIDATING": "Validation dépenses",
      "EVENT_IS_FINISHED": "Évènement terminé"
    }
  }
}
